/**
 * Created by Gaplo917 on 9/7/2017.
 */

export default {
  textStyles:{
    chinese: (fontSize) => {
      return {
        fontFamily: 'EPHKaiHK-Medium',
        fontSize: fontSize,
      }
    },
    pinyin:(fontSize) => {
      return {
        fontFamily: 'EPH_PINYIN',
        fontSize: fontSize,
      }
    },
    timer:(fontSize) => {
      return {
        fontFamily: 'Arial',
        fontSize: fontSize,
      }
    }
  },
  scenes: {
    START: 1,
    SELECTION: 2,
    LEVEL_1: 3,
    LEVEL_2: 4,
    LEVEL_3: 5,
    END_GAME: 6,
  },
  dimen: {
    width: 1024 * 2,
    height: 768 * 2,
  },
  settings: {
    common: {
      timer : 225,
      totalCorrectQuestions : 12,
      totalQuestions : 35
    },
    level1Settings: {
      level : 'level1'
    },
    level2Settings: {
      level : 'level2'
    },
    level3Settings: {
      level : 'level3'
    }
  },
  images: {
    initBg: { name: 'initBg', src: 'static/img/index_bg.png' },
    startBtn: { name: 'startBtn', src: 'static/img/btn_start.png' },
    selectStageBg: { name: 'selectStageBg', src: 'static/img/selection_bg.png'},
    startGame: { name: 'startGame', src: 'static/img/start_game.png'},
    tipsBtn: { name: 'tipsBtn', src: 'static/img/btn_tips.png'},
    returnBtn: { name: 'returnBtn', src: 'static/img/home_btn-21.png'},
    btnLevel1: { name: 'btnLevel1', src: 'static/img/btn_level1.png'},
    btnLevel2: { name: 'btnLevel2', src: 'static/img/btn_level2.png'},
    btnLevel3: { name: 'btnLevel3', src: 'static/img/btn_level3.png'},
    timerBox: { name: 'timerBox', src: 'static/img/timer_box.png'},
    checkPointArrow: { name: 'checkPointArrow', src: 'static/img/check_point_arrow.png'},
    infoBg: { name: 'infoBg', src: 'static/img/info_bg.png' },
    success_01: { name: 'success_01', src: 'static/img/success_01.png' },
    success_02: { name: 'success_02', src: 'static/img/success_02.png' },
    success_03: { name: 'success_03', src: 'static/img/success_03.png' },
    fail_01: { name: 'fail_01', src: 'static/img/fail_01.png' },
    fail_02: { name: 'fail_02', src: 'static/img/fail_02.png' },
    fail_03: { name: 'fail_03', src: 'static/img/fail_03.png' },
    end: { name: 'end', src: 'static/img/end.png' },
    selectionBtnPlay: { name: 'selection_btn_PLAY', src: 'static/img/selection_btn_PLAY.png' },
    selectionBtnRE: { name: 'selection_btn_RE', src: 'static/img/selection_btn_RE.png' },

    // LEVEL 1
    level1Bg1: { name: 'level1Bg1', src: 'static/img/level1_bg_g1.png' },
    level1Bg2: { name: 'level1Bg2', src: 'static/img/level1_bg_g2.png' },
    questionBox : { name: 'questionBox', src: 'static/img/question_box.png'},
    level1Choice1 : { name: 'level1Choice1', src: 'static/img/level1_choice1.png'},
    level1Choice2 : { name: 'level1Choice2', src: 'static/img/level1_choice2.png'},
    heart : { name: 'heart', src: 'static/img/heart.png'},
    heartEmpty : { name: 'heartEmpty', src: 'static/img/heart_empty.png'},
    heartBox : { name: 'heartBox', src: 'static/img/heart_box.png'},
    key : { name: 'key', src: 'static/img/key.png'},
    lizard : { name: 'lizard', src: 'static/img/lizard.png'},
    speechBubble : { name: 'speechBubble', src: 'static/img/speech_bubble.png'},
    stone : { name: 'stone', src: 'static/img/stone.png'},
    door_01 : { name: 'door_01', src: 'static/img/door_01.png'},
    door_02 : { name: 'door_02', src: 'static/img/door_02.png'},
    arrow : { name: 'arrow', src: 'static/img/arrow.png'},
    fireball : { name: 'fireball', src: 'static/img/fireball.png'},

    // LEVEL 2
    level2_bg: { name: 'level2_bg', src: 'static/img/level2_bg.png' },
    level2Choice1 : { name: 'level2Choice1', src: 'static/img/level2_choice1.png'},
    level2Choice2 : { name: 'level2Choice2', src: 'static/img/level2_choice2.png'},
    column01: { name: 'column01', src: 'static/img/column01.png' },
    column02: { name: 'column02', src: 'static/img/column02.png' },
    column03: { name: 'column03', src: 'static/img/column03.png' },
    beaconBack: { name: 'beaconBack', src:'static/img/fenghuotai_1.png'},
    beaconFront: { name: 'beaconFront', src:'static/img/fenghuotai_0.png'},

    // LEVLE 3
    level3_bg: { name: 'level3_bg', src: 'static/img/level3_bg.png' },
    river: { name: 'river', src: 'static/img/river.png' },
    level3Choice1 : { name: 'level3Choice1', src: 'static/img/level3_choice1.png'},
    level3Choice2 : { name: 'level3Choice2', src: 'static/img/level3_choice2.png'},
    big_stone: { name: 'big_stone', src: 'static/img/big_stone.png' },
    small_wooden: { name: 'small_wooden', src: 'static/img/small_wooden.png' },
    cobweb: { name: 'cobweb', src: 'static/img/cobweb.png' },
    timeBar: { name: 'Time_B', src: 'static/img/Time_B.png' },
    clock: { name: 'clock', src: 'static/img/clock.png' },

    end_game_bg: { name: 'end_game_bg', src: 'static/img/end_game_bg.png' },

    // End Game
    map: { name: 'map', src: 'static/img/ditu.png' }
  },
  sounds: {
    game_feedback_bad: {
      src: ['static/sound/game_feedback_bad.mp3'],
      volume: 1
    },
    game_feedback_good: {
      src: ['static/sound/game_feedback_good.mp3'],
      volume: 1
    },
    pth_6bs2_p52_ga_01: {
      src: ['static/sound/pth_6bs2_p52_ga_01.mp3'],
      volume: 1
    },
    pth_6bs2_p52_ga_02: {
      src: ['static/sound/pth_6bs2_p52_ga_02.mp3'],
      volume: 1
    },
    bg_6bg1_bg1: {
      //背景音樂
      src: ['static/sound/CORP56.mp3'],
      volume: 0.2,
      loop: true
    },
    bg_6bg1_bg2: {
      //背景音樂
      src: ['static/sound/ADVENT08.mp3'],
      volume: 0.2,
      loop: true
    },
    bg_6bg1_bg3: {
      //背景音樂
      src: ['static/sound/CORP04.mp3'],
      volume: 0.2,
      loop: true
    },

    click1: {
      //表示在本關要找出一條鎖匙，配聲效1
      src:['static/sound/CLICK1.mp3'],
      volume: 1
    },
    d: {
      //時限倒數音效
      src:['static/sound/fx04.mp3'],
      volume: 1
    },
    correct: {
      //答對聲效
      src:['static/sound/E023.mp3'],
      volume: 1
    },
    wrong: {
      //答錯聲效
      src:['static/sound/wrong.mp3'],
      volume: 1
    },
    pass_level1: {
      //過關音樂1
      src:['static/sound/E027.mp3'],
      volume: 1
    },
    fail_level1: {
      //過關失敗音樂
      src:['static/sound/S063.mp3'],
      volume: 1
    },
    pass_level2: {
      //過關音樂1
      src:['static/sound/COM01.mp3'],
      volume: 1
    },

    wrong_ans_eff_1: {
      //畫面上方降下許多火球
      src:['static/sound/missile_sfx.mp3'],
      volume: 1
    },
    wrong_ans_eff_2: {
      //畫面射出許多箭
      src:['static/sound/arrow2.mp3'],
      volume: 1
    },
    wrong_ans_eff_3: {
      //畫面左邊出現大石碌出
      src:['static/sound/Sfx_drop.mp3'],
      volume: 1
    },

    sfx_clap:{
      //完成遊戲 λ	拍手音效
      src:['static/sound/sfx_clap.mp3'],
      volume: 1
    },
    pth_6b_g1_vo01:{
      //野外歷險記
      src:['static/sound/pth_6b_g1_vo01.mp3'],
      volume: 1
    },
    pth_6b_g1_vo02:{
      //請選擇一個地方開始你的歷險旅程吧！
      src:['static/sound/pth_6b_g1_vo02.mp3'],
      volume: 1
    },
    pth_6b_g1_vo03:{
      //請判斷哪個是普通話詞語？
      src:['static/sound/pth_6b_g1_vo03.mp3'],
      volume: 1
    },
    pth_6b_g1_vo04:{
      //請判斷哪個量詞用得恰當？
      src:['static/sound/pth_6b_g1_vo04.mp3'],
      volume: 1
    },
    pth_6b_g1_vo05:{
      //請判斷哪句話符合普通話的語法？
      src:['static/sound/pth_6b_g1_vo05.mp3'],
      volume: 1
    },
    pth_6b_g1_vo06:{
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src:['static/sound/pth_6b_g1_vo06.mp3'],
      volume: 1
    },
    pth_6b_g1_vo07:{
      //成功：真棒！請你繼續接受挑戰吧！
      src:['static/sound/pth_6b_g1_vo07.mp3'],
      volume: 1
    },
    pth_6b_g1_vo08:{
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src:['static/sound/pth_6b_g1_vo08.mp3'],
      volume: 1
    },
    pth_6b_g1_vo09:{
      //成功：真棒！請你繼續接受挑戰吧！
      src:['static/sound/pth_6b_g1_vo09.mp3'],
      volume: 1
    },
    pth_6b_g1_vo10:{
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src:['static/sound/pth_6b_g1_vo10.mp3'],
      volume: 1
    },
    pth_6b_g1_vo11:{
      //遊戲結束：真棒！你做得非常好！
      src:['static/sound/pth_6b_g1_vo11.mp3'],
      volume: 1
    },

    level1_donkey: {
      //驢叫（給蛇嚇倒）
      src:['static/sound/LV1_donkey.mp3'],
      volume: 1
    },
    level1_dropstone: {
      //
      src:['static/sound/LV1_dropstone.mp3'],
      volume: 1
    },
    level1_flute: {
      src:['static/sound/LV1_flute.mp3'],
      volume: 1
    },
    level1_nod: {
      //頭像移動
      src:['static/sound/LV1_nod.mp3'],
      volume: 1
    },
    level2_fire: {
      //
      src:['static/sound/LV2_fire.mp3'],
      volume: 1
    },
    level2_movestone: {
      //
      src:['static/sound/LV2_movestone.mp3'],
      volume: 1
    },
    level2_movewood: {
      //
      src:['static/sound/LV2_movewood.mp3'],
      volume: 1
    },
    level2_woodpecker: {
      //
      src:['static/sound/LV2_woodpecker.mp3'],
      volume: 1
    },
    level3_dropapple: {
      //
      src:['static/sound/LV3_dropapple.mp3'],
      volume: 1
    },
    level3_flapwings: {
      //
      src:['static/sound/LV3_flapwings.mp3'],
      volume: 1
    },
    level3_splash: {
      //
      src:['static/sound/LV3_splash.mp3'],
      volume: 1
    },
    level3_turtle: {
      //
      src:['static/sound/LV3_turtle.mp3'],
      volume: 1
    },
  },
  string: {
  },
  spines: {
    snake:{
      id: 'she',
      json: 'static/spine/she.json',
      timeScale: 0.7,
      animations: {
        looking: 'run',
        stop: 'stop'
      }
    },
    camel:{
      id: 'luotuo',
      json: 'static/spine/luotuo.json',
      timeScale: 0.6,
      animations: {
        winking: 'Idle',
        walking: 'walk2',
        frighten: 'shoujing',
        protagonist: 'chipingguo',
        carryWalk: 'walk',
      }
    },
    eagle: {
      id: 'ying',
      json: 'static/spine/ying.json',
      timeScale: 0.5,
      animations: {
        flyingWithoutKey: 'walk2',
        flyingWithKey: 'walk',
        dropKey: 'diaoyaoshi',
      }
    },
    statue:{
      id: 'shixiang',
      json: 'static/spine/shixiang.json',
      timeScale: 0.7,
      animations: {
        nodding: 'shixiangyaotou',
      }
    },
    man: {
      id: 'xiaoyeren2',
      json: 'static/spine/xiaoyeren2.json',
      timeScale: 1,
      animations: {
        winking: 'stop',
        walking: 'run',
        ride: 'qicheng',
        hitOnFire: 'hit',
        hitByBow: 'hit2',
        hitByStone: 'hit3',
        pickingUp: 'jianditu',
        jump: 'jump'
      }
    },
    flute:{
      id: 'dizi',
      json: 'static/spine/dizi.json',
      timeScale: 0.5,
      animations: {
        animation: { track: 1, name: 'animation' },
      }
    },

    grass: {
      id: 'cao',
      json: 'static/spine/level2/cao.json',
      timeScale: 1,
      animations: {
        animation: 'animation'
      }
    },
    indian:{
      id: 'static/spine/level2/xiaoren2.json',
      json: 'static/spine/level2/xiaoren2.json',
      timeScale: 1,
      animations: {
        animation: 'animation',
        happy: 'jumubang'
      }
    },
    indianWithKey: {
      id: 'static/spine/level2/xiaoren.json',
      json: 'static/spine/level2/xiaoren.json',
      timeScale: 1,
      animations: {
        animation: 'animation',
        happy: 'jumubang'
      }
    },
    birdTower:{
      id: 'tuteng',
      json: 'static/spine/level2/tuteng.json',
      timeScale: 0.34,
      animations: {
        animation: 'animation',
      }
    },
    pecker: {
      id: 'zhuomuniao',
      json: 'static/spine/level2/zhuomuniao.json',
      timeScale: 1,
      animations: {
        idle: 'zhayan',
        peck: 'zhuomu'
      }
    },

    preFire:{
      id: 'huodui2',
      json: 'static/spine/level2/huodui2.json',
      timeScale: 0.5,
      animations: {
        settingWood: 'huodui',
        idleWood: 'huodui2',
        makingFire: 'huodui1',
      }
    },
    fire: {
      id: 'huo',
      json: 'static/spine/level2/huo.json',
      timeScale: 0.8,
      animations: {
        fire: 'animation',
      }
    },
    axeWood: {
      id: 'pimutou',
      json: 'static/spine/level2/pimutou.json',
      timeScale: 0.3,
      animations: {
        beforeAxe: 'mutou',
        axe: 'pimutou',

      }
    },
    beacon: {
      id: 'fenghuotai',
      json: 'static/spine/level2/fenghuotai.json',
      timeScale: 1,
      animations: {
        animation: 'animation',
      }
    },

    crocodile:{
      id: 'eyu',
      json: 'static/spine/level3/eyu.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        dead: 'shitouzhuan'
      }
    },
    tortoise: {
      id: 'level3/wugui',
      json: 'static/spine/level3/wugui.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        retracting: 'suoke',
        walking: 'zou'
      }
    },
    owl: {
      id: 'level3/maotouying',
      json: 'static/spine/level3/maotouying.json',
      timeScale: 1,
      animations: {
        idleWaked: 'daiji',
        idleSleeping: 'shuijiao',
        flying: 'maotouyingfei',
        flyingWithStick: 'daizoushuzhi',
        hitByApple: 'pingguozatou'
      }
    },
    spider:{
      id: 'level3/zhizhu',
      json: 'static/spine/level3/zhizhu.json',
      timeScale: 0.6,
      animations: {
        idle: 'daiji',
        animation: 'zhizhuwangshangpa',
      }
    },
    woodBox: {
      id: 'level3/muxiang',
      json: 'static/spine/level3/muxiang.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        open: 'dakai'
      }
    }
  },
  spriteSheets:{},
  vos: {

    /* dynamic inject in loadVO, just provide some schema*/
    vo: {
      src: [],
      volume: 1,
    }
  },
  question: {
    /* dynamic inject, just provide some schema*/
    level1: [{ "choice1" : "奶酪", "choice2" : "芝士", "answer" : "奶酪" }],
    level2: [{ "choice1" : "一間學校", "choice2" : "一所學校", "answer" : "一所學校" }],
    level3: [{ "choice1" : "多吃一點兒吧！", "choice2" : "吃多些啦！", "answer" : "多吃一點兒吧！" }],
  },
  delay: {
    afterAnswerEachQuestion: 2000
  }
}



// WEBPACK FOOTER //
// ./src/game/config/R.js